namespace GeniuzPOS.InventoryReport {
    export interface IcReport04_VListData extends Serenity.ListRequest {
        Header?: IcReport04_VRow;
    }
}
